// GSAP Animations


( function($) {

  

  window.onload = function(e){  // on load for GSAP
    gsap.registerPlugin(ScrollTrigger);
    console.log("gsap-animations.js ready");

    /* setInterval for interaction changes that affect body height and thus scrollTrigger calculations. 
    This is messy, but there are too many potential triggers to account for individually.
    Requires putting .js_scrollTrigger-watch class on any components that have scrolltriggers in them, otherwise it will run unnecessarily
      */
    
    var $element = $("body");
    var lastHeight = $("body").css('height');    
    if($('.js_scrollTrigger-watch').length){
       setInterval(function(){
         //console.log("checkForChanges: lastHeight = " + lastHeight);
          if ($element.css('height') != lastHeight){
              newHeight = $element.css('height');
              //console.log("body height has changed. lastHeight = " + lastHeight + " and newHeight = " + newHeight);
              ScrollTrigger.refresh();
              // reset lastHeight for future calculations
              lastHeight = newHeight; 
            }  
        }, 1000); 
    }

  



      // RESPONSIVE FUNCTIONS:
      ScrollTrigger.matchMedia({


        // lg destkop:
      "(min-width: 992px)": function() {
        // setup animations and ScrollTriggers for screens 992px wide or greater (bootstrap large) here...
        // The ScrollTriggers created inside these functions are segregated and get reverted/killed when the media query doesn't match anymore. 



      },

      // md-desktop: 
      "(min-width: 768px)": function() {
        // setup animations and ScrollTriggers for screens 768px wide or greater (bootstrap med) here...
        // The ScrollTriggers created inside these functions are segregated and get reverted/killed when the media query doesn't match anymore. 


        
        


      },

        // mobile: 
      "(max-width: 767px)": function() {

        
        

      },

      // all 
      "all": function() {
        // ScrollTriggers created here aren't associated with a particular media query,
        // so they persist.

            // =======================================================
            // ***** ALL: PARALLAX IMAGES ******
            // =======================================================
            gsap.utils.toArray(".js_parallax-window").forEach((section, i) => {
              section.bg = section.querySelector(".js_parallax-image"); 
              // Do the parallax effect on each section
                section.bg.style.backgroundPosition = `50% -4vw`,
                gsap.to(section.bg, {
                  backgroundPosition: `50% 4vw`,
                  ease: "none",
                  scrollTrigger: {
                    trigger: section,
                    start: "top 50%", 
                    end: "bottom 50%",
                    scrub: true,
                    markers: false
                  }
                });
            });
            // ***** END ALL: PARALLAX IMAGES ******


      }

    }); 





    }; // end GSAP on load wrapper

  
  

} ) ( jQuery );


$( window ).resize(function() {
  ScrollTrigger.refresh(true);
}); 